import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError } from 'rxjs';
import { errorHandl } from 'src/app/utils/network-utils';
import { urls } from 'src/app/utils/url.utils';

@Injectable({
  providedIn: 'root'
})
export class VendorService {

  constructor(private http: HttpClient) { }

  saveVendor(id: any, data: any) {
    const { company, ...payload } = data
    const companyId = company?.id || company?._id || company;

    if (id) {
      return this.http.put(urls.API_URL + urls.VENDORS + `/${companyId}/${id}`, payload)
        .pipe(catchError(errorHandl));
    }
    return this.http.post(urls.API_URL + urls.VENDORS + '/' + companyId, payload)
      .pipe(catchError(errorHandl));
  }

  getVendors(queryParams: any) {
    const params = new HttpParams({ fromObject: queryParams || {} });
    return this.http.get(urls.API_URL + urls.VENDORS, { params })
      .pipe(catchError(errorHandl));
  }

  getVendorById(id: any) {
    return this.http.get(urls.API_URL + urls.VENDORS + `/${id}`)
      .pipe(catchError(errorHandl));
  }

  syncVendor(companyId: any, vendorId: any, queryParams: any = {}) {
    const params = new HttpParams({ fromObject: queryParams || {} });
    return this.http.get(urls.API_URL + urls.VENDORS + `/${companyId}/${urls.SYNC}/${vendorId}`, { params })
      .pipe(catchError(errorHandl));
  }

  syncAllVendors(companyId: any) {
    return this.http.get(urls.API_URL + urls.VENDORS + `/${companyId}/${urls.SYNC}`)
      .pipe(catchError(errorHandl));
  }

}
